import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import React from 'react';

var spin = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' }
});

var SpinnerBox = styled.div(function () {
  var style = {
    marginTop: '10%',
    marginLeft: '10%',
    width: '80%',
    height: '80%',
    animation: spin + ' 1500ms linear infinite'
  };
  return style;
});

export var Spinner = function Spinner() {
  return React.createElement(
    SpinnerBox,
    null,
    React.createElement(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '100%',
        height: '100%',
        preserveAspectRatio: 'none',
        viewBox: '0 0 1060 1060',
        strokeWidth: '90',
        fill: 'none'
      },
      React.createElement('path', { stroke: '#eee', d: 'M 150 260 A 460 460 40 1 1 150 800' }),
      React.createElement('path', { stroke: '#aaa', d: 'M 150 260 A 460 460 40 0 0 150 800' })
    )
  );
};